export const getGridSize = (length) => {
  if (length % 3 === 0) return 4;
  if (length % 2 === 0) return 6;
  return 4;
};


export const isFutureDate = (batchEndDate) => {
  const today = new Date();
  const endDate = new Date(batchEndDate);

  // Remove time from today's date for accurate day comparison
  today.setHours(0, 0, 0, 0);

  return endDate > today;
};


export function groupSlotsByDay(input) {
  return Object.values(
    input.reduce((acc, { day, start_time, end_time }) => {
      if (!acc[day]) {
        acc[day] = { day, slots: [] };
      }
      acc[day].slots.push({ start_time, end_time });
      return acc;
    }, {})
  );
}


export function getTodayDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(today.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}




export function addDaysToToday(date, daysToAdd = 28) {
  const baseDate = new Date(date);
  baseDate.setDate(baseDate.getDate() + daysToAdd);

  const year = baseDate.getFullYear();
  const month = String(baseDate.getMonth() + 1).padStart(2, '0');
  const day = String(baseDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}


// export function addDaysToToday(daysToAdd = 30) {
//   const today = new Date();
//   today.setDate(today.getDate() + daysToAdd);

//   const year = today.getFullYear();
//   const month = String(today.getMonth() + 1).padStart(2, '0');
//   const day = String(today.getDate()).padStart(2, '0');

//   return `${year}-${month}-${day}`;
// }


export function formatToYYYYMMDD(dateInput) {
  if (!dateInput) return "";

  const date = new Date(dateInput);

  if (isNaN(date.getTime())) return "";

  return date.toISOString().slice(0, 10);
}







